class TimeTableRewardsParse {
    _personRewardsMap;
    columns;
    personsMap;
    constructor(periodRewards, rewardTypes) {
        this._personRewardsMap = {};
        this.personsMap = {};
        periodRewards?.forEach((r) => this.mapReward(r));
        this.columns = this.getColumns(rewardTypes);
    }
    mapReward(reward) {
        const parsedReward = this.getReward(reward);
        const internalRewardId = this.getBonusMapId(reward);
        const personId = reward.PersonBonus.PersonId;
        if (this._personRewardsMap[internalRewardId]) {
            this._personRewardsMap[internalRewardId].amount += parsedReward.amount;
            this._personRewardsMap[internalRewardId].entries.push(reward);
        }
        else {
            this._personRewardsMap[internalRewardId] = {
                ...parsedReward,
                entries: [reward]
            };
        }
        if (this.personsMap[personId]) {
            if (!this.personsMap[personId][parsedReward.rewardId]) {
                this.personsMap[personId][parsedReward.rewardId] = this._personRewardsMap[internalRewardId];
            }
        }
        else {
            this.personsMap[personId] = {
                [parsedReward.rewardId]: this._personRewardsMap[internalRewardId]
            };
        }
    }
    getColumns(rewardTypes) {
        return rewardTypes.map(({ Id, ShortName, Name, DailyBases }) => ({
            rewardId: Id,
            name: Name,
            shortName: ShortName,
            dailyBases: DailyBases || false
        })).sort((a, b) => a.shortName.localeCompare(b.shortName));
    }
    getReward(reward) {
        return ({
            rewardId: reward.PersonBonus.BonusId,
            amount: reward.Amount,
            enabled: !reward.PersonBonus?.Bonus?.IsDeleted || false,
            dailyBases: reward.PersonBonus?.Bonus?.DailyBases || false
        });
    }
    getBonusMapId(bonusEntry) {
        const bonusId = bonusEntry.PersonBonus.BonusId;
        const personId = bonusEntry.PersonBonus?.PersonId;
        return `${bonusId}-${personId}`;
    }
}
export default TimeTableRewardsParse;
